import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const authGuard: CanMatchFn = (route, segments) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.check().pipe(
        switchMap((authenticated) => {
            const redirectURL = `/${segments.map(s => s.path).join('/')}`;

            if (!authenticated && redirectURL !== '/firma-formulario-afiliacion') {
                return of(router.parseUrl('apl-afiliacion-onboarding'));
            }

            return of(true);
        })
    );
};
